import { gql } from "@apollo/client";

export const Get_Tags = gql`
  query {
    tags(take: 100) {
      items {
        id
        name
        tagColorId
        colorName
        code
      }
    }
  }
`;

export const Get_Tag_Colors = gql`
  query {
    tagColors(take: 50) {
      items {
        id
        name
        code
        textCode
      }
    }
  }
`;
